import type { PageNumber } from "@pdfking/renderer-api"
import type { StringGUID } from "@pdfking/tfunc"

import { CreateRandom } from "../random/CreateRandom"

export type BookPageKind = "blank" | "chapter" | "image" | "quote" | "text" | "title"

// Chapters open on the right, the odd pages (page 1 lies alone on the right),
// one in seven or so and never two in a row; page 3 always opens the first
const chapter_drawn = (seed: StringGUID, page: number): boolean =>
  page === 3 || (page > 3 && page % 2 === 1 && CreateRandom(seed, "chapter", page)() < 0.14)

export const ChapterQ = (seed: StringGUID, page: number): boolean =>
  chapter_drawn(seed, page) && !chapter_drawn(seed, page - 2)

// What a page of the book is, decided by its number and the seed alone, so
// any page knows what its neighbours are: a chapter opener is always preceded
// by a blank page
export const BookPageKind = (seed: StringGUID, page_number: PageNumber): BookPageKind => {
  if (page_number === 1) return "title"
  if (ChapterQ(seed, page_number)) return "chapter"
  if (ChapterQ(seed, page_number + 1)) return "blank"
  const draw = CreateRandom(seed, "image", page_number)()
  return draw < 0.15 ? "image" : draw < 0.22 ? "quote" : "text"
}

// The number of the chapter `page_number` lies in
export const ChapterNumber = (seed: StringGUID, page_number: PageNumber): number => {
  let count = 0
  for (let page = 3; page <= page_number; page += 2) if (ChapterQ(seed, page)) count++
  return count
}
